import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';

const CHECK_INTERVAL = 60_000; // check every 60s

const UpdateBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialHash = useRef(null);

  useEffect(() => {
    const fetchHash = async () => {
      try {
        const res = await fetch(`/asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const text = await res.text();

        if (!initialHash.current) {
          initialHash.current = text;
          return;
        }

        if (text !== initialHash.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // ignore network errors
      }
    };

    fetchHash();
    const interval = setInterval(fetchHash, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  if (!updateAvailable) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2.5,
        py: 1.5,
        borderRadius: 2,
        bgcolor: '#0f172a',
        border: '1px solid #22c55e',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        color: '#e2e8f0',
        maxWidth: 340,
      }}
    >
      <RefreshIcon sx={{ color: '#22c55e', fontSize: 28, animation: 'spin 2s linear infinite', '@keyframes spin': { from: { transform: 'rotate(0deg)' }, to: { transform: 'rotate(360deg)' } } }} />
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 14, color: '#fff' }}>
          Update Available
        </Typography>
        <Typography sx={{ fontSize: 12, color: '#94a3b8' }}>
          A new version is ready.
        </Typography>
      </Box>
      <Button
        variant="contained"
        size="small"
        onClick={async () => {
                  if ('caches' in window) {
                    const names = await caches.keys();
                    await Promise.all(names.map((n) => caches.delete(n)));
                  }
                  if ('serviceWorker' in navigator) {
                    const regs = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(regs.map((r) => r.unregister()));
                  }
                  window.location.reload();
                }}
        sx={{
          bgcolor: '#22c55e',
          color: '#000',
          fontWeight: 700,
          textTransform: 'none',
          '&:hover': { bgcolor: '#16a34a' },
        }}
      >
        Reload
      </Button>
      <IconButton size="small" onClick={() => setUpdateAvailable(false)} sx={{ color: '#64748b' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default UpdateBanner;
